module.exports = {"hello":"안녕","server":{"error":{"-1000":"사이트 정보를 확인 할 수 없습니다.","-1001":"현재 운영중인 사이트가 아닙니다."}}}